import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const notify = (type: "success" | "error" = 'success',message:string) => {
	const theme = 'light';
	switch (type) {
		case 'error':
			toast.error(message);
			break;
		case 'success':
			toast.success(message);
			break;
		default:
			toast.info(message);
			break;
	}
};

export default notify;
